import { render, staticRenderFns } from "./shop-list-search.vue?vue&type=template&id=280c7936&scoped=true"
import script from "./shop-list-search.vue?vue&type=script&lang=js"
export * from "./shop-list-search.vue?vue&type=script&lang=js"
import style0 from "./shop-list-search.vue?vue&type=style&index=0&id=280c7936&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c7936",
  null
  
)

export default component.exports